export default "__VITE_ASSET__zmPQaS0e__"